<template>
  <div class="d-flex justify-content-center">
    <button
      class="btn trigger-btn btn-sm"
      @click="openModal"
      :disabled="isLoading"
    >
      <span v-if="!isLoading">
        <img src="~@/assets/icon/clock-rotate-left-white.svg" alt="" />
      </span>
      <span
        v-else
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <p class="m-0" style="font-size: 12px">
        {{ isLoading ? "Loading..." : "Riwayat" }}
      </p>
    </button>

    <!-- Modal Lihat Riwayat -->
    <div v-if="versions.length > 0">
      <div class="modal fade modal-wrapper" id="referenceModal" role="dialog">
        <div
          class="modal-dialog modal-dialog-centered"
          style="max-width: 60vw"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                Detail Riwayat & Versioning BAST: {{ orderId }}
              </h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body timeline-modal-body">
              <div
                v-for="(data, index) in versions"
                class="timeline-item"
                :key="index"
              >
                <div :class="['timeline-marker', index > 0 ? 'v1' : 'v2']">
                  V{{ data.version }}
                </div>
                <div class="timeline-content">
                  <h6 class="timeline-title">
                    {{ data.title }}
                  </h6>
                  <p class="timeline-time">
                    Time: {{ formatDateToIndonesian(data.bastDate) }}
                  </p>

                  <div
                    v-if="data.lesseePic && data.asaniPic"
                    class="timeline-detail"
                  >
                    <p>
                      <strong>Pihak:</strong> Menyerahkan:
                      {{ data.asaniPic }} ({{ data.asaniRole }}) | Menerima:
                      {{ data.lesseePic }} ({{ data.lesseeRole }})
                    </p>
                  </div>

                  <div class="timeline-files">
                    <p class="timeline-files-label">
                      File Lampiran
                      {{ data.files.length > 1 ? "(Multi-File Upload)" : "" }}
                      {{
                        data.files.length === 1 && !data.files[0].path
                          ? "(Unsigned)"
                          : ""
                      }}:
                    </p>
                    <div
                      v-for="(file, index) in data.files"
                      class="file-item"
                      :key="index"
                    >
                      <img
                        class="mr-2"
                        src="~@/assets/icon/blue_file.svg"
                        alt="doc icon"
                      />
                      <span>{{ file.name }}</span>
                      <div class="file-actions">
                        <a
                          v-if="file.path"
                          :href="file.path + '?token=' + loginToken"
                          target="_blank"
                          class="action-link"
                          >Lihat</a
                        >
                        <a
                          href="javascript:void(0)"
                          @click="
                            file.path
                              ? downloadFile(file)
                              : downloadBlank(file.id)
                          "
                          class="action-link"
                          >Unduh</a
                        >
                      </div>
                    </div>
                  </div>

                  <div class="timeline-note">
                    <p><strong>Keterangan:</strong> {{ data.note }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalBASTHistory",
  props: {
    bastId: {
      type: Number,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      versions: [],
      isLoading: false,
      loginToken: localStorage.getItem("jwt") || "",
    };
  },
  methods: {
    closeModal() {
      this.versions = [];
    },
    formatDateToIndonesian(dateString) {
      // Convert "06-06-2026" to "5 Juni 2026"
      const monthNames = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      const [day, month, year] = dateString.split("-");
      const dayNumber = parseInt(day, 10); // Remove leading zero
      const monthIndex = parseInt(month, 10) - 1;

      return `${dayNumber} ${monthNames[monthIndex]} ${year}`;
    },

    async openModal() {
      this.isLoading = true;
      try {
        await this.getBastVersionHistory();
        $("#referenceModal").modal("show");
      } catch (error) {
        console.error("Error opening modal:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async getBastVersionHistory() {
      try {
        const response = await this.$http.get(
          process.env.GET_BAST_VERSION_HISTORY + `/${this.bastId}`,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status == 200) {
          this.versions = response.data.content;
        } else {
          const errMessage =
            response.data && response.data.message
              ? response.data.message
              : "Failed to fetch BAST version history";
          swal("Error", errMessage, "error");
          throw new Error(errMessage);
        }
      } catch (error) {
        console.error("Error fetching BAST version history:", error);
        const errMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : error.message || "Failed to fetch BAST version history";
        swal("Error", errMessage, "error");
        throw error;
      }
    },

    async downloadFile(file) {
      try {
        const response = await this.$http.get(
          process.env.GET_BAST_FILE_ATTACHMENT + `/${file.id}`,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
            responseType: "blob",
          }
        );

        // Create blob URL from response data
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        const errorResponse =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          "Failed to download file";
        console.error("Error downloading file:", error);
        swal("Error", errorResponse, "error");
      }
    },

    downloadBlank(fileId) {
      this.$http
        .post(
          process.env.DOWNLOAD_BLANK,
          {
            bastId: fileId,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        )
        .then((res) => {
          this.loadingDownload = false;
          const linkSource = `data:application/pdf;base64,${res.data.content}`;
          const downloadLink = document.createElement("a");
          const fileName = "BAST-" + this.orderId + ".pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        })
        .catch((error) => {
          this.loadingDownload = false;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
  },
};
</script>

<style scoped>
.trigger-btn {
  font-size: 14px;
  padding: 6px 12px;
  background-color: #455f84;
  border: none;
  color: white;
  display: flex;
  gap: 6px;
  align-items: center;
  transition: opacity 0.3s ease;
  border-radius: 6px;
}

.trigger-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.trigger-btn:hover:not(:disabled) {
  background-color: #364657;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

.modal-wrapper {
  font-family: "inter";
}

.timeline-modal-body {
  max-height: 500px;
  overflow-y: auto;
  padding: 16px 0;
}

.timeline-item {
  display: flex;
  margin-bottom: 20px;
  padding: 0 16px;
  position: relative;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: 40px;
  top: 60px;
  bottom: -20px;
  width: 2px;
  background: #e0e0e0;
  z-index: 0;
}

.timeline-item:last-child::before {
  display: none;
}

.timeline-marker {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 16px;
  flex-shrink: 0;
  z-index: 1;
  margin-right: 16px;
  border: 5px solid #fff;
}

.timeline-marker.v2 {
  background: #2196f3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
}

.timeline-marker.v1 {
  background: #90a1b9;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
}

.timeline-content {
  flex: 1;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
  border: 1px solid #cfd3d9;
}

.timeline-title {
  margin: 0 0 4px 0;
  font-weight: 600;
  font-size: 14px;
  color: #2e3646;
}

.timeline-time {
  margin: 0 0 8px 0;
  font-size: 12px;
  color: #666;
}

.timeline-detail {
  margin: 8px 0;
  font-size: 13px;
  color: #2e3646;
  line-height: 1.4;
}

.timeline-files {
  margin: 10px 0;
}

.timeline-files-label {
  font-size: 12px;
  color: #2e3646;
  margin: 0 0 8px 0;
  font-weight: 500;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 8px;
  background: white;
  border-radius: 8px;
  margin-bottom: 6px;
  border: 1px solid #e0e0e0;
}

.file-item i {
  margin-right: 8px;
  color: #2196f3;
  font-size: 16px;
}

.file-item span {
  flex: 1;
  font-size: 12px;
  color: #2e3646;
}

.file-actions {
  display: flex;
  gap: 8px;
}

.action-link {
  font-size: 11px;
  color: #2196f3;
  text-decoration: none;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 3px;
  transition: background 0.2s;
}

.action-link:hover {
  background: rgba(33, 150, 243, 0.1);
  text-decoration: underline;
}

.timeline-note {
  margin-top: 8px;
  padding: 8px;
  padding-left: 0;
  border-top: 1px solid #cfd3d9;
}

.timeline-note p {
  margin: 0;
  font-size: 12px;
  color: #2e3646;
}

.timeline-note strong {
  color: #2e3646;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/CustomComponent/BAST/ModalBASTHistory.vue